import GET_CATEGORIES from "../plugins/getCategories"

const [ w, d, content, mq ] = [ window, document, 'news', window.matchMedia("(max-width: 900px)") ]

const replace_item = obj => {
  let href = obj.getAttribute('href')
  let thumb = obj.querySelector('.thum_img > img').getAttribute('src')
  let is_new = obj.querySelectorAll('span.new').length > 0 ? true : false
  let catObj = obj.querySelector('.catetitle a')
  let cat = catObj ? catObj.innerText : ''
  let dateObj = obj.querySelector('p.date')
  let date = dateObj ? dateObj.innerText : false
  let title = obj.querySelector('h5 > a').getAttribute('title')
  let desc = obj.querySelector('p.catch')? obj.querySelector('p.catch').innerText : ''

  $(obj).replaceWith(`
  <a class="${content}-item" href="${href}">
    <figure class="${content}-item__img">
      <div class="${content}-item__img-cover" style="background-image:url(${thumb})">
        <img src="${thumb}" width="200">
      </div>
    </figure>
    <div class="${content}-item__body">
      <div class="${content}-item__title">
        <span class="date-cate">
          <small class="date">${date}</small>｜<span class="cate">${cat}</span>
        </span>
        <span class="subject ${is_new? ' is-new': ''}">${title}</span>
      </div>
    </div>
  </a>
  `)
}

const init  = () => {

}

const list_init = (cat=false) => {
  $('.contents .wrapLink', '.element_list').each((i, obj) => replace_item(obj) );

  // カテゴリ一覧取得
  $(`<div class="${content}-catelist" data-plugin="getCategories" data-content="${content}"><p class="text-center"><i class="fa fa-circle-o-notch fa-spin text-grey fa-fw"></i>&nbsp;Loading...</p></div>`).insertAfter('.breadcrumbs');
  GET_CATEGORIES(`.${content}-catelist[data-plugin="getCategories"]`, { content, addAll: true } );
}


// 詳細ページにて実行
const detail_init = async post_id => {
  let the_article = await $.getArticles({ content, post_id, post_status: 'all' });
  let categories = await $.getCategories({ content });
  the_article = the_article.shift();
  the_article.category = categories.filter( c => c.id == the_article.category ).shift();

  // タグボックス
  let tags = keywords => {
    let html = ""
    if(!keywords || keywords.length == 0) return ''
    keywords.forEach( key => html += `<a href="/${content}/?mode=list&tag=${ encodeURI( key ) }" class="tag">#${key}</a>` )
    return `<div class="${content}-detail__tags">${html}</div>`
  }

  // 詳細置き換え
  $('.element_detail').each( ( i, elm_detail ) => {
    let $head = $(`
      <div class="${content}-detail__head">
        <span class="date-cate">
          <span class="date">${w.datetostr( the_article.date * 1000, 'YYYY.MM.DD' )}</span>｜${the_article.category ? `<span class="cate">${the_article.category.name}</span>`: '<span class="cat">その他</span>' }
        </span>
        <h3 class="title${the_article.is_new? ' is-new': ''}">${the_article.title}</h3>
      </div>
    `)
    $('.element_detail > .title, .detail_title').remove()

    $head.prependTo( elm_detail )

    $('.news-detail__head','.element_detail').append( tags( the_article.keywords ) )

  })

}


export default function NEWS () {

  // 一覧ページのテンプレート(Vue template)
  const itemTemplate = `
    <div id="main" class="column-3-4">
      <transition-group class="${content}-list" tag="div" name="fade" mode="out-in" :class="[ 'is-paged-' + paged ]">
        <a class="${content}-item" :href="article.href" v-for="( article, ind ) in pagedArticles" :key="article.id" :class="[ 'is-item-' + ind ]">
          <figure class="${content}-item__img">
            <div class="${content}-item__img-cover" :style="'background-image:url(' + article.thumb + ')'">
              <img :src="article.thumb" width="200" decoding="async">
            </div>
          </figure>
          <div class="${content}-item__body">
            <div class="${content}-item__title">
              <span class="date-cate">
                <small class="date">{{ datetostr(article.date * 1000 ,"YYYY/MM/DD")}}</small>｜<span class="cate" :class="'is-cat'+article.category.id" v-if="article.category">{{ article.category.name }}</span><span class="cate" v-else="article.category">その他</span>
              </span>
              <span class="subject">
                {{ article.title | truncate(60) }}<span class="new" v-if="article.is_new">NEW</span>
              </span>
            </div>
            <div class="tags" v-if="article.keywords != null">
              <span class="tag" v-for="tag in article.keywords">#{{tag}}</span>
            </div>
          </div>
        </a>
      </transition-group>
      <pagination
        v-if="totalPage > 1"
        :paged="paged"
        :total-page="totalPage"
        :total-item="totalItem"
        :item-count="pagedArticles.length"
        :prevText="'Prev'"
        :nextText="'Next'"
        @change="pageChange"
      />
    </div>
  `



  $(() => {
    init()
    if( w.query_string('mode') == 'list' || $('.element_list').length ) list_init( w.query_string('cat') );
    if( w.query_string('article') || $('.element_detail').length ) detail_init( w.query_string('article') );
  });
}